import { jsx as _jsx } from "react/jsx-runtime";
import RecommendationsSection from './RecommendationsSection';
import { getRecommendationsMetadataList //@ts-expect-error Could not find declaration file for module
} from '../../selectors/recommendationsSelectors';
import { FormattedMessage, FormattedReactMessage } from 'LearningCenterUI/components/I18n';
import { isInterestFieldDefined } from '../../utils/interestUtils';
import UsageTracker from '../../utils/UsageTracker';
import { useRecommendations, useRecommendationsTopicPreference } from '../../features/recommendations';
import { useSelector } from 'react-redux';
import { OverviewSource } from '../../features/tracks';
import { RouterLink } from '../AcademyLinks';

const TopicBasedReason = ({
  topic,
  source
}) => {
  const hasTopic = isInterestFieldDefined(topic);

  const setLearningInterestLink = () => {
    UsageTracker.track('interaction', {
      action: 'field-recommendation-set-learning-interest-clicked'
    });
  };

  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `learningCenter.tracks.subheaders.${hasTopic ? source === 'JOB_FIELD' ? 'becauseJobField' : 'becauseInterest' : 'becauseNotSet'}`,
    options: {
      roleName: /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "topic-preference-label",
        message: `learningCenter.learningTopics.options.${topic}`
      }),
      setFieldLink: /*#__PURE__*/_jsx(RouterLink, {
        "data-test-id": "preference-change-button",
        onClick: setLearningInterestLink,
        to: "/wizard",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.fieldLink.set`
        })
      })
    }
  });
};

const SubTitle = ({
  metadataList,
  savedTopicPreference
}) => {
  if (savedTopicPreference) {
    const {
      topic,
      source
    } = savedTopicPreference;
    return /*#__PURE__*/_jsx(TopicBasedReason, {
      source: source,
      topic: topic
    });
  }

  if (!metadataList.length) return null;
  const {
    preferredTopic,
    source
  } = metadataList[0];

  if (preferredTopic) {
    return /*#__PURE__*/_jsx(TopicBasedReason, {
      source: source,
      topic: preferredTopic
    });
  }

  return null;
};

const RecommendationsBasedOnField = () => {
  const {
    recommendationsTopicPreference
  } = useRecommendationsTopicPreference();
  const {
    recommendations: response
  } = useRecommendations();
  const {
    recommendations
  } = response || {};
  const metadataList = useSelector(state => getRecommendationsMetadataList(state, recommendations));
  if (!recommendations) return null;
  return /*#__PURE__*/_jsx(RecommendationsSection, {
    recommendations: recommendations,
    source: OverviewSource.RecommendationsField,
    subTitle: /*#__PURE__*/_jsx(SubTitle, {
      metadataList: metadataList,
      savedTopicPreference: recommendationsTopicPreference
    }),
    testId: "recommendations-based-on-field"
  });
};

export default RecommendationsBasedOnField;